export default function FAQ() {
  return (
    <div className="container py-5">
      <h2 className="mb-4 gradient-text">FAQ</h2>

      <div className="accordion glass p-3">
        <div className="accordion-item bg-transparent border-0">
          <button className="accordion-button bg-transparent text-white">
            What do you offer?
          </button>
          <div className="accordion-body text-light">
            Web, cloud, and SaaS solutions.
          </div>
        </div>
      </div>
    </div>
  );
}
